import { fetchTopOrganizations } from "@/api/landing";
import { generateOrganizationsRandomGradient } from "@/utils/gradients";

export default {
  namespaced: true,
  state: {
    topOrganizations: [],
    loading: false,
  },
  mutations: {
    SET_TOP_ORGANIZATIONS(state, topOrganizations) {
      state.topOrganizations = topOrganizations;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async loadTopOrganizations({ commit, state }) {
      if (state.topOrganizations.length > 0) return;
      commit("SET_LOADING", true);
      try {
        const response = await fetchTopOrganizations();

        const organizationsWithBackground = response.data.map((org, index) => ({
          ...org,
          background: generateOrganizationsRandomGradient(index),
        }));

        commit("SET_TOP_ORGANIZATIONS", organizationsWithBackground);
      } catch (error) {
        console.error("Ошибка загрузки категорий:", error);
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
  getters: {
    getTopOrganizations: (state) => state.topOrganizations,
    isTopOrganizationsLoading: (state) => state.loading,
  },
};
